const rows = document.querySelectorAll('#select .list .row');
const startButton = document.querySelector('#select button');
let quizID;

rows.forEach(row => {
    row.addEventListener('click', () => {
        rows.forEach(row => row.classList.remove('selected'));
        row.classList.add('selected');
        quizID = row.dataset.id;
        startButton.disabled = false;
    });
});

startButton.addEventListener('click', () => {
    window.location.href = quizID;
});